// src/components/CierreDia.jsx

export default function CierreDia({
  fecha,
  setFecha,
  pagos,
  resumen,
  loading,
  error,
}) {
  return (
    <div className="cierre-panel">
      <div className="pagos-actions">
        <div>
          <label>
            Fecha:
            <input
              type="date"
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
            />
          </label>
        </div>
      </div>

      {loading ? (
        <p>Cargando cierre de día...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <>
          <div className="cierre-resumen">
            <div className="cierre-card">
              <strong>Total día:</strong> {resumen.total.toFixed(2)} €
            </div>
            <div className="cierre-card">
              <strong>Efectivo:</strong> {resumen.efectivo.toFixed(2)} €
            </div>
            <div className="cierre-card">
              <strong>Tarjeta:</strong> {resumen.tarjeta.toFixed(2)} €
            </div>
            <div className="cierre-card">
              <strong>Nº pagos:</strong> {resumen.count}
            </div>
          </div>

          {pagos.length === 0 ? (
            <p>No hay pagos en esta fecha.</p>
          ) : (
            <table className="pv-table pagos">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Paciente</th>
                  <th>Especialidad</th>
                  <th>Servicio</th>
                  <th>Importe (€)</th>
                  <th>Método</th>
                </tr>
              </thead>
              <tbody>
                {pagos.map((p) => (
                  <tr key={p.id}>
                    <td>{new Date(p.date).toLocaleDateString("es-ES")}</td>
                    <td
                      className="paciente-cell"
                      title={`${p.paciente} ${p.apellidos || ""}`}
                    >
                      <strong>{p.paciente}</strong> {p.apellidos}
                    </td>
                    <td>{p.specialty_name || p.specialty_code || "—"}</td>
                    <td>{p.service_name || "-"}</td>
                    <td style={{ textAlign: "center" }}>{p.amount} €</td>
                    <td>
                      {p.payment_method === "efectivo"
                        ? "💵 Efectivo"
                        : "💳 Tarjeta"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      )}
    </div>
  );
}
